var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { roundOffWithZeros } from "@domains/utils/numberMethods";
import React, { useState } from "react";
import ReportValue from "../../../../../../shared-library/components/commonTableVal";
var BrokingAccordionTableBody = function (props) {
    var _a = __read(useState(), 2), dpcData = _a[0], setDpcData = _a[1];
    React.useEffect(function () {
        setDpcData(props.data);
    }, [props.data]);
    var _b = __read(React.useState([false]), 2), openAcc = _b[0], setOpenAcc = _b[1];
    var profiletableSublistHead = [
        {
            title: "Transaction Date",
            key: "TransactionDate",
        },
        {
            title: "Running Amount (Rs)",
            key: "RunningAmount",
        },
        {
            title: "Days",
            key: "days",
        },
        {
            title: "Interest Rate (%)",
            key: "interestRate",
        },
        {
            title: "Interest Amount (Rs)",
            key: "interestAmount",
        },
    ];
    return (React.createElement(React.Fragment, null, dpcData &&
        dpcData.length > 0 &&
        dpcData.map(function (dpc, idx) {
            return (React.createElement("tr", { key: idx },
                React.createElement("div", { className: "profile-test-block1 ".concat(openAcc[idx] ? "openAccmain" : "") },
                    React.createElement("table", { className: "table common-table " },
                        React.createElement("tbody", null,
                            React.createElement("tr", { className: "profile-main-tablebody-tr ".concat(openAcc[idx] ? "openAcc" : "") },
                                React.createElement("td", { colSpan: 4 },
                                    React.createElement("span", { className: "hand_cursor" },
                                        React.createElement("i", { className: openAcc[idx]
                                                ? "edel-icon-arrow-up"
                                                : "edel-icon-arrow-down", onClick: function () {
                                                var temp = __spreadArray([], __read(openAcc), false);
                                                temp[idx] = !temp[idx];
                                                setOpenAcc(temp);
                                            } })),
                                    React.createElement("span", { className: "arrowicon-td" }, dpc.month)),
                                React.createElement("td", { colSpan: 4 },
                                    React.createElement(ReportValue, { stream: false, onlyval: false, val: dpc.amount }))),
                            openAcc[idx] && (React.createElement(React.Fragment, null,
                                React.createElement("tr", { className: "profile-main-tablebody-sub-tr" }, profiletableSublistHead.map(function (items) {
                                    return React.createElement("td", null, items.title);
                                })),
                                dpc.dpC_ChargeDetails &&
                                    dpc.dpC_ChargeDetails.length > 0 &&
                                    dpc.dpC_ChargeDetails.map(function (subList, idx) {
                                        return (React.createElement("tr", { className: "profile-main-tablebody-sub-tr", key: idx },
                                            React.createElement("td", null, subList.transactionDate),
                                            React.createElement("td", null,
                                                React.createElement(ReportValue, { stream: false, onlyval: false, val: subList.runAmount })),
                                            React.createElement("td", null, subList.days),
                                            React.createElement("td", null, subList.interest),
                                            React.createElement("td", null, roundOffWithZeros(Number(subList.interestAmt)))));
                                    }))))))));
        })));
};
export default BrokingAccordionTableBody;
